import * as process from 'process';
window['process'] = process;

(window as any)['global'] = window;

import * as buffer from 'buffer';
window['Buffer'] = buffer.Buffer;

// import * as http from 'http';
// window['Agent'] = http.Agent;

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for evergreen browsers supported by Angular 15.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/**
 * Required to support Web Animations `@angular/platform-browser/animations`.
 * Needed for: All but Chrome, Firefox and Opera. http://caniuse.com/#feat=web-animation
 */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Additional legacy browser polyfills can be added here if a future requirement needs them.
 */
// import 'intl';  // Run `npm install --save intl`.
/**
 * Import locale data alongside `intl` only if that polyfill is explicitly reintroduced.
 */
// import 'intl/locale-data/jsonp/en';
